import { render, staticRenderFns } from "./Step8.vue?vue&type=template&id=f8ad6ce0&lang=pug"
import script from "./Step8.vue?vue&type=script&lang=js"
export * from "./Step8.vue?vue&type=script&lang=js"
import style0 from "./Step8.vue?vue&type=style&index=0&id=f8ad6ce0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports